import React from 'react';
import { Icon } from './Icon';
import { useTheme } from '../hooks/useTheme';
import { setThemePreference } from '../utils/theme';

// One-click switch between the light and dark themes. "Follow the device
// setting" is available in Settings.
export const ThemeToggle = ({ className = '' }) => {
  const theme = useTheme();
  const next = theme === 'dark' ? 'light' : 'dark';
  const label = `Switch to ${next} theme`;

  return (
    <button
      type="button"
      className={`btn-secondary btn-icon theme-toggle ${className}`.trim()}
      onClick={() => setThemePreference(next)}
      aria-label={label}
      title={label}
    >
      <Icon name={theme === 'dark' ? 'sun' : 'moon'} />
    </button>
  );
};
